import {SchemaInterfaceExtendingSchema, TagSchemaSupportedFolderItemType} from 'constants/RegistryConstants';
import {TagSchemaSequenceSchemaType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {FieldType, SchemaField} from 'schemas/fields/SchemaFieldConstants';

import {
  SchemaInterfaceWithFieldsGraphQL,
  SchemaInterfaceWithFieldsGraphQL_SchemaInterfaceNode_fields_SchemaInterfaceFieldNode as SchemaInterfaceFieldNode,
} from '../../../../graphql-fragments/schemas/schema-interfaces/__generated/SchemaInterfaceWithFieldsGraphQL';
import {BaseBioentityType} from '../SchemaInterfaceBaseBioentityTypeDropdown';

export function mapSchemaInterfaceFieldGraphQLToSchemaField(
  interfaceFieldNode: SchemaInterfaceFieldNode
): SchemaField {
  return {
    id: interfaceFieldNode.id,
    dbId: interfaceFieldNode.id,
    apiId: interfaceFieldNode.apiId,
    name: interfaceFieldNode.displayName,
    systemName: interfaceFieldNode.systemName,
    displayName: interfaceFieldNode.displayName,
    fieldType: interfaceFieldNode.fieldType as FieldType,
    isRequired: interfaceFieldNode.isRequired,
    isMulti: interfaceFieldNode.isMulti,
    isComputed: interfaceFieldNode.isComputed,
    isConvertedFromLink: false,
    isSnapshot: false,
    isIntegration: false,
    isParentLink: false,
    requiredLink: interfaceFieldNode.requiredLinkJson,
    schemaFieldSelectorId: interfaceFieldNode.schemaFieldSelectorId,
    archiveRecord: null,
    tooltipText: null,
  };
}

export function mapSchemaInterfaceGraphQLToSchemaInterfaceExtendingSchema(
  schemaInterfaceGraphQL: SchemaInterfaceWithFieldsGraphQL
): SchemaInterfaceExtendingSchema {
  const allFields: Array<SchemaField> = schemaInterfaceGraphQL.fields.map((field) =>
    mapSchemaInterfaceFieldGraphQLToSchemaField(field)
  );

  const baseBioentityType: BaseBioentityType | null = schemaInterfaceGraphQL.baseBioentityType
    ? {
        folderItemType: schemaInterfaceGraphQL.baseBioentityType
          .folderItemType as TagSchemaSupportedFolderItemType,
        sequenceType: schemaInterfaceGraphQL.baseBioentityType
          .sequenceType as TagSchemaSequenceSchemaType | null,
      }
    : null;

  return {
    id: schemaInterfaceGraphQL.id,
    name: schemaInterfaceGraphQL.name,
    baseBioentityType,
    allFields,
    fields: allFields,
    archiveRecord: schemaInterfaceGraphQL.archiveRecord,
  };
}
